import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import ReactTooltip from 'react-tooltip';
import { Stack, Inline, Text, textVariants } from '@etg/wings';
import { useEffect, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const genericStyles = css`
  max-width: 240px;
`;
const SeatToolTip = _ref => {
  let {
    id,
    price,
    seat
  } = _ref;
  const {
    t
  } = useTranslation();
  const tooltipSeatLabel = t('Product.SeatMap.Tooltip.Select');
  const tooltipPriceLabel = t('Product.SeatMap.Tooltip.Price');
  const [seatId, setSeatId] = useState('');
  useEffect(() => {
    setSeatId(id);
  }, [id]);
  return /*#__PURE__*/_jsx(ReactTooltip, {
    className: cx('etiTooltip', genericStyles),
    effect: "solid",
    globalEventOff: "touchstart",
    id: id,
    children: /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsxs(Inline, {
        children: [tooltipSeatLabel, /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: seat
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        noWrap: true,
        children: [tooltipPriceLabel, /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: priceUtil.formatPrice(price)
        })]
      })]
    })
  }, `key-${seatId}`);
};
export default SeatToolTip;
//# sourceMappingURL=SeatTooltip.js.map